import React, { useContext, useState } from 'react'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import { Offcanvas } from 'react-bootstrap'
import Addmoney from './AddMoney'
import UserContext from '../context/UserContext'
import { useSelector } from 'react-redux'

export default function Header() {
  const profileData = useSelector((state) => state.profileData)
  const navigate = useNavigate()
  const pathname = useLocation().pathname
  const context = useContext(UserContext)
  const { modal, setModal, headerSearch, setHeaderSearch } = context

  const handleHeaderSearch = (value) => {
    setHeaderSearch(value)
    if (value.trim() && pathname !== '/') {
      navigate('/')
    }
  }

  const signoutHandler = () => {
    setModal({ ...modal, sideNav: false })
    localStorage.removeItem('authToken')
    navigate('/send-otp')
  }

  const [showSearch, setShowSearch] = useState(false)

  const handleLinkClick = () => {
    setShowSearch(!showSearch)
  }

  return (
    <>
      <Addmoney modal={modal} setModal={setModal} />

      <header className='bg-white shadow-sm sticky-top'>
        <nav className='bg-white py-3'>
          <div className='container d-flex align-items-center justify-content-between'>
            
            {/* LEFT SIDE: Hamburger / Back & Logo */}
            <div className='d-flex align-items-center' style={{ flex: '1 1 0' }}>
              {pathname === '/' ? (
                <button className='navbar-toggler back-btn me-3 d-lg-none' type='button' onClick={() => setModal({ ...modal, sideNav: true })}>
                  <svg className='icon'>
                    <use href='#icon_menu'></use>
                  </svg>
                </button>
              ) : (
                <button type='button' onClick={() => navigate(-1)} className='navbar-toggler back-btn me-3 d-lg-none'>
                  <svg className='icon'>
                    <use href='#icon_backarrow'></use>
                  </svg>
                </button>
              )}

              <Link to='/' className='navbar-brand me-0 d-flex align-items-center'>
                <img src='/images/Logo.svg' alt='Logo' style={{ height: '36px', objectFit: 'contain' }} />
              </Link>
            </div>

            {/* MIDDLE: Search Box (Desktop Only) */}
            <div className='d-none d-md-flex position-relative mx-3' style={{ flex: '0 1 400px', minWidth: 0 }}>
              <div className='position-relative w-100'>
                <input
                  className='form-control rounded-pill search-field w-100'
                  type='search'
                  placeholder='Search games...'
                  aria-label='Search'
                  value={headerSearch}
                  onChange={(e) => handleHeaderSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      handleHeaderSearch(e.target.value)
                    }
                  }}
                  style={{ paddingLeft: '45px', paddingRight: '20px', backgroundColor: '#f6f7f9', border: '1px solid #e2e4e8', height: '44px' }}
                />
                <svg className='icon position-absolute' style={{ left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d', pointerEvents: 'none', fontSize: '20px' }}>
                  <use href='#icon_search'></use>
                </svg>
              </div>
            </div>

            {/* RIGHT SIDE: Wallet, Profile, Country */}
            <div className='d-flex align-items-center justify-content-end' style={{ flex: '1 1 0' }}>
              {localStorage.getItem('authToken') ? (
                <>
                  <button type='button' className='btn-coin rounded-pill shadow-sm d-flex align-items-center border px-2 py-1' onClick={() => setModal({ ...modal, addMoney: true })} style={{ backgroundColor: '#fff', border: '1px solid #eaeaea' }}>
                    <img src='/images/coin.svg' alt='coin' style={{ height: '22px' }} />
                    <span className='fw mx-2 fs-6 text-dark'>{Number(profileData.walletBalance ?? profileData.wallet ?? 0).toFixed(2)}</span>
                    <img src='/images/rounded-plus.svg' alt='plus' style={{ height: '22px' }} />
                  </button>

                  <button 
                    type='button' 
                    onClick={() => navigate('/profile')} 
                    className='btn btn-light rounded-circle ms-3 ms-md-3 d-flex align-items-center justify-content-center p-0 shadow-sm border border-1 overflow-hidden'
                    style={{ width: '38px', height: '38px', backgroundColor: '#f8f9fa' }}
                    title={profileData?.name || 'Profile'}
                  >
                    <img src={profileData?.profilePicture || '/images/user.svg'} alt='user' style={{ width: profileData?.profilePicture ? '40px' : '20px', height: profileData?.profilePicture ? '40px' : '20px', objectFit: 'cover' }} />
                  </button>
                </>
              ) : (
                <Link
                  to='/send-otp'
                  className='btn btn-login rounded-pill fw-500 d-inline-flex align-items-center justify-content-center text-center text-decoration-none'
                >
                  Login
                </Link>
              )}

              <div className='country-box ms-md-4 ms-2 d-none d-lg-block'>
                <button type='button' className='country-btn d-flex align-items-center bg-transparent border-0' data-bs-toggle='collapse' data-bs-target='#collapseCountryList'>
                  <img src='/images/india-flag.svg' alt='flag' />
                  <span className='mx-1 fw-500'>IN</span>
                  <svg className='icon'>
                    <use href='#icon_chevrondown'></use>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </nav>

        {/* Desktop Navbar Links */}
        <div className='d-none d-lg-block border-top bg-white'>
          <div className='container py-2'>
            <div className='navbar-nav flex-row d-flex justify-content-evenly w-100 fs-16px fw-500'>
              <Link className='nav-link text-dark px-3' aria-current='page' to='/'>Home</Link>
              <Link className='nav-link text-dark px-3' to='/reports?type=purchase'>Orders</Link>
              <Link className='nav-link text-dark px-3' to='/my-wallet'>My Wallet</Link>
              <Link className='nav-link text-dark px-3' to='/profile'>Profile</Link>
              <Link className='nav-link text-dark px-3' to='/about-us'>About Us</Link>
              <Link className='nav-link text-dark px-3' to={pathname}>Reseller</Link>
            </div>
          </div>
        </div>
      </header>

      <Offcanvas show={modal.sideNav} onHide={() => setModal({ ...modal, sideNav: false })} className='offcanvas offcanvas-start' tabindex='-1' id='offcanvasExample' aria-labelledby='offcanvasExampleLabel'>
        <div className='offcanvas-header'>
          <div className='offcanvas-logo'>
            <Link to='/' className='w-100'>
              <img src='/images/logo.png' />
            </Link>
          </div>
          <button type='button' className='btn-close' data-bs-dismiss='offcanvas' aria-label='Close' onClick={() => setModal({ ...modal, sideNav: false })}></button>
        </div>
        <div className='offcanvas-body position-relative'>
          <ul className='offcanvas-aside'>
            <li>
              <NavLink className='nav-link' to='/profile'>
                <span>
                  <svg className='icon'>
                    <use href='#icon_profile'></use>
                  </svg>
                </span>
                <strong>Profile</strong>
                <svg className='icon ms-auto'>
                  <use href='#icon_rightarrow'></use>
                </svg>
              </NavLink>
            </li>
            <li>
              <NavLink className='nav-link' to='/reports?type=purchase'>
                <span>
                  <svg className='icon'>
                    <use href='#icon_order'></use>
                  </svg>
                </span>
                <strong>Orders</strong>
                <svg className='icon ms-auto'>
                  <use href='#icon_rightarrow'></use>
                </svg>
              </NavLink>
            </li>
            <li>
              <NavLink className='nav-link' to='/my-wallet'>
                <span>
                  <svg className='icon'>
                    <use href='#icon_wallet'></use>
                  </svg>
                </span>
                <strong>My Wallet</strong>
                <svg className='icon ms-auto'>
                  <use href='#icon_rightarrow'></use>
                </svg>
              </NavLink>
            </li>
            <li>
              <NavLink className='nav-link' to='/support'>
                <span>
                  <svg className='icon'>
                    <use href='#icon_chat'></use>
                  </svg>
                </span>
                <strong>Help & Support</strong>
                <svg className='icon ms-auto'>
                  <use href='#icon_rightarrow'></use>
                </svg>
              </NavLink>
            </li>
            <li>
              <NavLink className='nav-link' to='/'>
                <span>
                  <svg className='icon'>
                    <use href='#icon_handshake'></use>
                  </svg>
                </span>
                <strong>Reseller</strong>
                <svg className='icon ms-auto'>
                  <use href='#icon_rightarrow'></use>
                </svg>
              </NavLink>
            </li>
            <li>
              <NavLink className='nav-link' to='/about-us'>
                <span>
                  <svg className='icon'>
                    <use href='#icon_info'></use>
                  </svg>
                </span>
                <strong>About Us</strong>
                <svg className='icon ms-auto'>
                  <use href='#icon_rightarrow'></use>
                </svg>
              </NavLink>
            </li>
            <li>
              <NavLink className='nav-link' to='/'>
                <span>
                  <svg className='icon'>
                    <use href='#icon_share'></use>
                  </svg>
                </span>
                <strong>Share</strong>
                <svg className='icon ms-auto'>
                  <use href='#icon_rightarrow'></use>
                </svg>
              </NavLink>
            </li>
          </ul>
          <button type='button' className='btn rounded-pill' onClick={signoutHandler}>
            <svg className='icon me-1'>
              <use href='#icon_logout'></use>
            </svg>
            Log out
          </button>
        </div>
      </Offcanvas>

    </>
  )
}
